<nav class="model-navbar">
	<ul class="main-nav dz-flex-lg dz-hidden-md dz-hidden-sm dz-hidden dz-justify-content-left-lg margin-left-64 padding-bottom-8 dz-text-14">
		<li class="nav-item" *ngFor="let route of routesList">
			<a class="nav-link margin-horizontal-20 padding-bottom-8" [routerLink]="route.path" routerLinkActive="active" [dcrHTMLKey]="route.text.dcrKey">{{
				route.text.dcrValue
			}}</a>
		</li>
	</ul>

	<div class="select dz-block-md dz-block-sm dz-block dz-hidden-lg" (click)="showDropdown = !showDropdown">
		<span class="select-title dz-flex-md dz-flex-sm dz-flex dz-justify-content-left-md dz-justify-content-left-sm dz-justify-content-left padding-16"
			>{{ title }}
			<dz-icon class="icon dz-flex-md dz-flex-sm dz-flex" *ngIf="!showDropdown" type="chevron-down"></dz-icon>
			<dz-icon class="icon dz-flex-md dz-flex-sm dz-flex" *ngIf="showDropdown" type="chevron-up"></dz-icon>
		</span>
		<ul class="select-ul-list dz-flex-md dz-flex-sm dz-flex dz-align-items-top-md dz-align-items-top-sm dz-align-items-top padding-horizontal-16" *ngIf="showDropdown">
			<li class="select-li-list dz-block-md dz-block-sm dz-block padding-vertical-8" *ngFor="let route of routesList" (click)="changeDropdownTitle(route)">
				<a [routerLink]="route.path" routerLinkActive="active" [dcrHTMLKey]="route.text.dcrKey">{{ route.text.dcrValue }}</a>
			</li>
		</ul>
	</div>
</nav>
